import { Box, Grid } from '@mui/material';
import React, { ReactNode } from 'react';

import { LegacyHelpDialog } from '~/legacy-components/LegacyHelpDialog';

import { useSxStyles } from './useStyles';

export type LegacyFieldWrapperPropsFragment = {
  label?: string;
  highlightLabel?: boolean;
  required?: boolean;
  fieldError?: { type?: string; message?: string };
  help?: {
    title: string;
    content: ReactNode;
  };
};

type Props = LegacyFieldWrapperPropsFragment & {
  fieldId?: string;
  children?: ReactNode | JSX.Element;
};

export const LegacyFieldWrapper = (props: Props) => {
  const {
    label,
    highlightLabel,
    fieldId,
    fieldError,
    children,
    required,
    help,
  } = props;
  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.fieldComponent}>
      {label && (
        <Box
          component={'label'}
          htmlFor={fieldId}
          sx={{
            ...sxStyles.fieldLabel,
            ...(highlightLabel ? sxStyles.highlightLabel : {}),
          }}
        >
          {label}:{' '}
          {required && <Box component={'i'} sx={sxStyles.required}></Box>}
          {help && (
            <LegacyHelpDialog content={help.content} title={help.title} />
          )}
        </Box>
      )}

      {children}
      {!!fieldError && !!fieldError.message && (
        <Grid item>
          <Box component={'span'} sx={sxStyles.errorMsgText}>
            {fieldError.message}
          </Box>
        </Grid>
      )}
    </Box>
  );
};
